import Cookies from 'js-cookie';

import { fechFromBPartsApi } from '../utils';

export const fetchPartAlerts = async ({
  locale,
}: {
  locale: string;
}): Promise<Array<TPartAlert>> => {
  const data = await fechFromBPartsApi(`/${locale}/shop/alerts`, undefined, {
    enableCustomErrorWrapper: false,
  });

  return data.json();
};

export const deletePartAlert = async ({
  locale,
  alertId,
}: {
  locale: string;
  alertId: number;
}): Promise<void> => {
  const data = await fechFromBPartsApi(
    `/${locale}/shop/alerts/${encodeURI(alertId)}`,
    {
      method: 'DELETE',
      credentials: 'include',
      headers: new Headers([
        ['Content-Type', 'application/json'],
        ['X-CSRFToken', Cookies.get('csrftoken') || ''],
      ]),
    },
      );

  return data.json();
};

export const createPartAlertForAuthUser = async (
  variables: TSaveResquest
): Promise<void> => {
  const response = await fechFromBPartsApi(
    `/${variables.locale}/shop/alerts/create-auth`,
    {
      method: 'post',
      credentials: 'include',
      headers: new Headers([
        ['Content-Type', 'application/json'],
        ['X-CSRFToken', variables.csrftoken],
        ['b-origin', process.env.NEXT_PUBLIC_TENANT || '1'],
      ]),
      body: JSON.stringify(variables.formData),
    },
    {
      enableCustomErrorWrapper: false,
    }
  );

  if (response.status === 201) {
    return;
  }
  if (response.status === 403) {
    throw { notAutorized: true };
  }
  let json;
  try {
    json = await response.json();
  } catch (error) {
    throw { serverError: error };
  }

  if (!response.ok) {
    throw json;
  }
  return;
};

export const createPartAlertForNoAuthUser = async (
  variables: TSaveResquest
): Promise<void> => {
  const response = await fechFromBPartsApi(
    `/${variables.locale}/shop/alerts/create-no-auth`,
    {
      method: 'post',
      credentials: 'include',
      headers: new Headers([
        ['Content-Type', 'application/json'],
        ['X-CSRFToken', variables.csrftoken],
        ['b-origin', process.env.NEXT_PUBLIC_TENANT || '1'],
      ]),
      body: JSON.stringify(variables.formData),
    },
      );

  if (response.status === 201) {
    return;
  }
  if (response.status === 403) {
    throw { notAutorized: true };
  }
  let json;
  try {
    json = await response.json();
  } catch (error) {
    throw { serverError: error };
  }

  if (!response.ok) {
    throw json;
  }
  return;
};
